/**
 * Ce que l'abonnement décide, sans DOM.
 *
 * Deux choses seulement : reconnaître le code promo, et savoir où en est la
 * cascade de relances de la Steveletter. Les deux sont ici pour être vérifiées
 * au caractère près — la cascade surtout, dont la seule promesse est
 * qu'**elle finit**.
 */

/** Le code promo qui donne 200 % de réduction. Il fait aussi autre chose. */
export const PROMO_CODE = 'steve';

/**
 * Vrai quand la saisie vaut le code promo.
 *
 * Tolérant comme un vrai champ de code promo : casse, espaces et accents sont
 * ignorés. On ne fait pas rater une blague à quelqu'un pour une majuscule.
 */
export function isPromoCode(input: string): boolean {
  return (
    input
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') === PROMO_CODE
  );
}

/**
 * État de la pop-up : le nombre de refus déjà opposés au visiteur.
 *
 * `0` = la pop-up d'origine, personne n'a encore essayé de fermer. `n` = la
 * n-ième relance est à l'écran. `'closed'` = terminé, et **ce n'est pas
 * réversible** de la visite.
 */
export type NagState = number | 'closed';

/**
 * Ce que devient la pop-up quand le visiteur essaie de la fermer.
 *
 * **La cascade finit** : passé la dernière relance, elle se ferme pour de bon.
 * Une boucle sans fin ne serait plus une blague, juste un site hostile — et le
 * seul moyen de s'en assurer est de le vérifier ici, pas à l'œil.
 */
export function refuse(step: NagState, total: number): NagState {
  if (step === 'closed') return 'closed';
  const next = Math.max(0, Math.trunc(step)) + 1;
  return next > total ? 'closed' : next;
}

/**
 * Le texte à afficher pour un état donné, ou `null` pour la pop-up d'origine.
 *
 * L'indice est borné : les listes FR et EN pourraient un jour ne plus avoir la
 * même longueur, et une relance manquante laisserait une bulle vide à l'écran.
 */
export function nagText(step: NagState, messages: readonly string[]): string | null {
  if (step === 'closed' || step <= 0 || messages.length === 0) return null;
  return messages[Math.min(step, messages.length) - 1] ?? null;
}
